import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ModalConfig {
    title?: string;
    message?: string;
    showCancel?: boolean;
    confirmText?: string;
    cancelText?: string;
    icon?: 'warning' | 'info' | 'error' | 'success';
}

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    private configSubject = new BehaviorSubject<ModalConfig | null>({
        title: '',
        message: '',
        showCancel: false,
        confirmText: 'Ok',
        cancelText: 'Cancel',
        icon: 'info'
    });

    config$ = this.configSubject.asObservable();

    private visibleSubject = new BehaviorSubject<boolean>(false);

    visible$ = this.visibleSubject.asObservable();

    private resolve?: (result: boolean) => void;

    open(config: ModalConfig): Promise<boolean> {

        this.configSubject.next({
            ...this.configSubject.value,
            ...config
        });

        this.visibleSubject.next(true);

        return new Promise<boolean>((resolve) => {
            this.resolve = resolve;
        });
    }

    confirm(): void {
        this.close(true);
    }

    cancel(): void {
        this.close(false);
    }

    close(result = false): void {
        this.visibleSubject.next(false);

        if (this.resolve) {
            this.resolve(result);
            this.resolve = undefined;
        }
    }
}